import * as actionTypes from '../types/modal';

export function modalPostStockOpen(payload) {
  return {
    type: actionTypes.MODAL_POST_STOCK_OPEN,
    payload
  };
}

export function modalPostStockClose(payload) {
  return {
    type: actionTypes.MODAL_POST_STOCK_CLOSE,
    payload
  };
}

export function modalPostStockConsignmentOpen(payload) {
  return {
    type: actionTypes.MODAL_POST_STOCK_CONSIGNMENT_OPEN,
    payload
  };
}

export function modalPostStockConsignmentClose(payload) {
  return {
    type: actionTypes.MODAL_POST_STOCK_CONSIGNMENT_CLOSE,
    payload
  };
}

export function modalShipmentCheckFIFOOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_CHECK_FIFO_OPEN,
    payload
  };
}
export function modalShipmentCheckFIFOClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_CHECK_FIFO_CLOSE,
    payload
  };
}

export function modalShipmentSubmergeOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_SUBMERGE_OPEN,
    payload
  };
}

export function modalShipmentSubmergeClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_SUBMERGE_CLOSE,
    payload
  };
}

export function modalShipmentRedeemConsignmentOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_REDEEM_CONSIGNMENT_OPEN,
    payload
  };
}

export function modalShipmentRedeemConsignmentClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_REDEEM_CONSIGNMENT_CLOSE,
    payload
  };
}

export function modalShipmentPlanReadyOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_PLAN_READY_OPEN,
    payload
  };
}

export function modalShipmentPlanReadyClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_PLAN_READY_CLOSE,
    payload
  };
}

export function modalShipmentReturnOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_RETURN_OPEN,
    payload
  };
}

export function modalShipmentReturnClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_RETURN_CLOSE,
    payload
  };
}

export function modalSKOpen(payload) {
  return {
    type: actionTypes.MODAL_SK_OPEN,
    payload
  };
}
export function modalSKClose(payload) {
  return {
    type: actionTypes.MODAL_SK_CLOSE,
    payload
  };
}
export function modalSKCreate(payload) {
  return {
    type: actionTypes.MODAL_SK_CREATE,
    payload
  };
}
export function modalSKCreateSuccess(payload) {
  return {
    type: actionTypes.MODAL_SK_CREATE_SUCCESS,
    payload
  };
}
export function modalSKCreateFail(payload) {
  return {
    type: actionTypes.MODAL_SK_CREATE_FAIL,
    payload
  };
}

export function modalSKZipOpen(payload) {
  return {
    type: actionTypes.MODAL_SK_ZIP_OPEN,
    payload
  };
}
export function modalSKZipClose(payload) {
  return {
    type: actionTypes.MODAL_SK_ZIP_CLOSE,
    payload
  };
}
export function modalSKZipCreate(payload) {
  return {
    type: actionTypes.MODAL_SK_ZIP_CREATE,
    payload
  };
}
export function modalSKZipCreateSuccess(payload) {
  return {
    type: actionTypes.MODAL_SK_ZIP_CREATE_SUCCESS,
    payload
  };
}
export function modalSKZipCreateFail(payload) {
  return {
    type: actionTypes.MODAL_SK_ZIP_CREATE_FAIL,
    payload
  };
}

export function modalStatusClear(payload) {
  return {
    type: actionTypes.MODAL_STATUS_CLEAR,
    payload
  };
}

export function modalProcessingStartOpen(payload) {
  return {
    type: actionTypes.MODAL_PROCESSING_START_OPEN,
    payload
  };
}
export function modalProcessingStartClose(payload) {
  return {
    type: actionTypes.MODAL_PROCESSING_START_CLOSE,
    payload
  };
}

export function modalShipmentPlanOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_PLAN_OPEN,
    payload
  };
}
export function modalShipmentPlanClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_PLAN_CLOSE,
    payload
  };
}

export function modalShipmentPlanCancelOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_PLAN_CANCEL_OPEN,
    payload
  };
}
export function modalShipmentPlanCancelClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_PLAN_CANCEL_CLOSE,
    payload
  };
}

export function modalMessageOpen(payload) {
  return {
    type: actionTypes.MODAL_MESSAGE_OPEN,
    payload
  };
}
export function modalMessageClose(payload) {
  return {
    type: actionTypes.MODAL_MESSAGE_CLOSE,
    payload
  };
}

export function modalAddMessageOpen(payload) {
  return {
    type: actionTypes.MODAL_ADD_MESSAGE_OPEN,
    payload
  };
}
export function modalAddMessageClose(payload) {
  return {
    type: actionTypes.MODAL_ADD_MESSAGE_CLOSE,
    payload
  };
}

export function modalQRLinkOpen(payload) {
  return {
    type: actionTypes.MODAL_QR_LINK_OPEN,
    payload
  };
}
export function modalQRLinkClose(payload) {
  return {
    type: actionTypes.MODAL_QR_LINK_CLOSE,
    payload
  };
}

export function modalShipmentCancelReasonOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_CANCEL_REASON_OPEN,
    payload
  };
}
export function modalShipmentCancelReasonClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_CANCEL_REASON_CLOSE,
    payload
  };
}

export function modalShipmentCancelReasonConsignmentOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_OPEN,
    payload
  };
}
export function modalShipmentCancelReasonConsignmentClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_CLOSE,
    payload
  };
}

export function modalDeletingPieceOpen(payload) {
  return {
    type: actionTypes.MODAL_DELETING_PIECE_OPEN,
    payload
  };
}
export function modalDeletingPieceClose(payload) {
  return {
    type: actionTypes.MODAL_DELETING_PIECE_CLOSE,
    payload
  };
}

export function modalAwaitingProcessingStartOpen(payload) {
  return {
    type: actionTypes.MODAL_AWAITING_PROCESSING_START_OPEN,
    payload
  };
}
export function modalAwaitingProcessingStartClose(payload) {
  return {
    type: actionTypes.MODAL_AWAITING_PROCESSING_START_CLOSE,
    payload
  };
}
export function modalShipmentAddReportOverdueOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_ADD_REPORT_OVERDUE_OPEN,
    payload
  };
}
export function modalShipmentAddReportOverdueClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_ADD_REPORT_OVERDUE_CLOSE,
    payload
  };
}
export function modalShipmentSZRebindingOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_SZ_REBINDING_OPEN,
    payload
  };
}
export function modalShipmentSZRebindingClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_SZ_REBINDING_CLOSE,
    payload
  };
}

export function modalAddCommentOpen(payload) {
  return {
    type: actionTypes.MODAL_ADD_COMMENT_OPEN,
    payload
  };
}

export function modalAddCommentClose(payload) {
  return {
    type: actionTypes.MODAL_ADD_COMMENT_CLOSE,
    payload
  };
}

export function modalOnHoldOpen(payload) {
  return {
    type: actionTypes.MODAL_ON_HOLD_OPEN,
    payload
  };
}
export function modalOnHoldClose(payload) {
  return {
    type: actionTypes.MODAL_ON_HOLD_CLOSE,
    payload
  };
}
// Модальное окно опроса
export function modalSurveyOpen(payload) {
  return {
    type: actionTypes.MODAL_SURVEY_OPEN,
    payload
  };
}
export function modalSurveyClose(payload) {
  return {
    type: actionTypes.MODAL_SURVEY_CLOSE,
    payload
  };
}
export function modalShipmentClientArrivalDateOpen(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_CLIENT_ARRIVAL_DATE_OPEN,
    payload
  };
}
export function modalShipmentClientArrivalDateClose(payload) {
  return {
    type: actionTypes.MODAL_SHIPMENT_CLIENT_ARRIVAL_DATE_CLOSE,
    payload
  };
}

export function modalSelectFieldsOpen(payload) {
  return {
    type: actionTypes.MODAL_SELECT_FIELDS_OPEN,
    payload
  };
}
export function modalSelectFieldsClose(payload) {
  return {
    type: actionTypes.MODAL_SELECT_FIELDS_CLOSE,
    payload
  };
}
